import React, { useMemo } from 'react';
import { useHistory, useIntl } from 'umi';
import { get } from 'lodash-es';
import { storeRankJumpLinkConfig } from '@intelligence/pages/TopCharts/components/StoreRankDetailsCore/components/Visualis/components/config';

import './index.scss';

interface IJumpToTopCharts {
  entityType: string;
  currentFetchSource: string[];
}

function JumpToTopCharts({ entityType = 'pc', currentFetchSource }: IJumpToTopCharts) {
  const history = useHistory();
  const { formatMessage } = useIntl();

  const jumpLink = useMemo<string | undefined>(() => {
    const path = [entityType, currentFetchSource?.[0]];
    const link = get(storeRankJumpLinkConfig, path);
    return link;
  }, [entityType, currentFetchSource]);

  const handleJumpTextClick = () => {
    jumpLink && history.push(jumpLink);
  };

  return jumpLink ? (
    <div className="dbi-store-rank-jump-top-charts-text" onClick={handleJumpTextClick}>
      {formatMessage({ id: 'dbi_store_rank_view_store_rank_top_charts' })}
    </div>
  ) : null;
}

export default JumpToTopCharts;
